import { LanguageLoader } from '../../assets/languages';

export const IsRequiredEmpty = (value, fieldDef) =>
{
	if (fieldDef && (fieldDef.type === 'enum' || fieldDef.type === 'multienum'))
	{
		if (value === '0' || value === 0 || value === undefined || value === null || value === '')
		{
			return true;
		}
		if (Array.isArray(value))
		{
			return value.filter(item => item !== '0' && item !== 0 && item !== '' && item != null).length === 0;
		}
		return false;
	}

	if (Array.isArray(value))
	{
		const activeItems = value.filter((item) => {
			if (item === undefined || item === null || item === '')
			{
				return false;
			}
			if (typeof item === 'object')
			{
				if (Object.keys(item).length === 0)
				{
					return false;
				}
				if (item.deleted && item.deleted !== 0 && item.deleted !== '0')
				{
					return false;
				}
			}
			return true;
		});
		return activeItems.length === 0;
	}

	return (!value || (typeof value === 'string' && value === "") || (typeof value === 'object' && !value.length));
};

export const ValidateField = (dataEntry, fields) =>
{
	const errors = [];
	const selectedLanguage = localStorage.getItem("language");
	const language = LanguageLoader(selectedLanguage);
	for(const field in fields) 
	{
		const fieldErrors = [];
		const value = dataEntry[field];
		const rules = fields[field].validation;
		if(!rules || rules.length === 0)
		{
			continue;
		}
		for(const rule of rules)
		{
			if (rule === 'required' && IsRequiredEmpty(value, fields[field]))
			{
				fieldErrors.push(language.ERROR.IS_REQUIRED);
			}
			else
			{
				if(value)
				{
					switch(rule) 
					{
						case "numeric":
							if(!/^\d+$/.test(value)) 
							{
								fieldErrors.push(language.ERROR.WRONG_DATA);
							}
							break;
						case "national_code":
							const type = dataEntry.type ? dataEntry.type : 'Individual';
							if(!CheckNationalCode(value, type)) 
							{
								fieldErrors.push(language.ERROR.WRONG_DATA);
							}
							break;
						case "postal_code":
							if(!CheckPostalCode(value)) 
							{
								fieldErrors.push(language.ERROR.WRONG_POSTAL_CODE);
							}
							break;
						case "phone":
							if (!CheckPhoneNumber(value))
							{
								fieldErrors.push(language.ERROR.WRONG_PHONE_NUMBER_ERROR);
							}
							break;
						case "email":
							if (!CheckEmail(value))
							{
								fieldErrors.push(language.ERROR.WRONG_EMAIL_ERROR);
							}
							break;
						default:
							if (rule.startsWith("min_length:")) 
							{
								const minLength = parseInt(rule.split(":")[1], 10);
								if (value.length < minLength)
								{
									fieldErrors.push(language.ERROR.WRONG_LENGTH);
								}
							}
							else if (rule.startsWith("max_length:")) 
							{
								const maxLength = parseInt(rule.split(":")[1], 10);
								if (value.length > maxLength) 
								{
									fieldErrors.push(language.ERROR.WRONG_LENGTH);
								}
							} 
							else if (rule.startsWith("length_between:")) 
							{
								const [minLength, maxLength] = rule.split(":")[1].split("-").map(Number);
								if (value.length < minLength || value.length > maxLength) 
								{
									fieldErrors.push(language.ERROR.WRONG_LENGTH);
								}
							}
							else if (rule.startsWith("exact_length:")) 
							{
								const exactLength = parseInt(rule.split(":")[1], 10);
								if (value.length !==  exactLength) 
								{
									fieldErrors.push(language.ERROR.WRONG_LENGTH);
								}
							}
						break;
					}
				}
			}
		}
		if(fieldErrors.length > 0)
		{
			errors[field] = fieldErrors;
		}
	}
	return errors;
};

export const CheckEmail = emails =>
{
	if(typeof emails === 'string' && emails.length)
	{
		emails = [{email_address: emails}];
	}
	for(const item of emails)
	{
		let email = item.email_address;
		const regex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
		if (email.length === 0 || regex.test(email.trim()) === false)
		{
			return false;
		}
	}
    return true;
}

export const CheckPhoneNumber = numbers =>
{
	if((typeof numbers === 'string' || typeof numbers === 'number') && numbers.length)
	{
		numbers = [{'number':numbers, type:''}];
	}
	for(const item of numbers)
	{
		let number = item.number;
		if (number.length === 0 || !number)
		{
			return false;
		}
		else if(item.type === 'Mobile' && number.length < 11)
		{
			return false;
		}
	}
    return true;
}

export const CheckNationalCode = (code, type) =>
{
	if(type === 'Individual')
	{
		if(code.length === 10)
		{
			if(code==='1111111111' || code==='2222222222' || code==='3333333333' || code==='4444444444' || code==='5555555555'  || code==='6666666666'  || code==='7777777777'  || code==='8888888888'  || code==='9999999999' )
			{
				return false;
			}
			else
			{
				const c = parseInt(code.charAt(9));
				const n = parseInt(code.charAt(0))*10 + parseInt(code.charAt(1))*9 + parseInt(code.charAt(2))*8 + parseInt(code.charAt(3))*7 + parseInt(code.charAt(4))*6 + parseInt(code.charAt(5))*5 + parseInt(code.charAt(6))*4 + parseInt(code.charAt(7))*3 + parseInt(code.charAt(8))*2;
				const r = n - parseInt(n/11)*11;
				if((r === 0 && r === c) || (r === 1 && c === 1) || (r > 1 && c === 11 - r))
				{
					return true;
				}
				else
				{
					return false;
				}
			}
		}
		else
		{
			return false;
		}
	}
	else if(type === 'Corporate')
	{
		if(code.length < 11 || parseInt(code,10) === 0)
		{
			return false;
		}
		if(parseInt(code.substr(3,6),10) === 0)
		{
			return false;
		}
		var c = parseInt(code.substr(10,1),10);
		var d = parseInt(code.substr(9,1),10)+2;
		var z = [29, 27, 23, 19, 17];
		var s = 0;
		for(var i=0; i<10; i++)
		{
			s += (d+parseInt(code.substr(i,1),10)) * z[i%5];
		}
		s = s%11; if(s === 10) s = 0;
		return (c === s);
	}
	else
	{
		return false;
	}
}

export const CheckPostalCode = (postalCode) => 
{
	var postalCodePattern = /^\d{10}$/;
	if (!postalCodePattern.test(postalCode)) 
	{
		return false;
	}
	var lastDigit = parseInt(postalCode[9]);
	if (lastDigit >= 0 && lastDigit <= 6) 
	{
		return true;
	}

	return false;
} 